import React from "react";

import styles from "../JobShiftPreStart/JobShiftPreStartView.module.css";

const getRevisionNumber = (version) => {
  if (version === undefined || version === null || version === "") {
    return "1";
  }

  const value = `${version}`;
  return value.charAt(0).toLowerCase() === "v" ? value.slice(1) || "1" : value;
};

export default function JobShiftReadinessViewHeader({ sections = {}, readiness = {}, context = {} }) {
  const projectDetails = sections.document_project_details
    && sections.document_project_details.data
    ? sections.document_project_details.data
    : {};
  const orgDetails = projectDetails.org_details || {};
  const orgName = orgDetails.name || "";
  const orgLetter = orgName ? orgName.charAt(0) : "";
  const swmsNumber = projectDetails.swms_number || context.swmsNumber || "";
  const readinessQuestions = readiness.rescue_readiness_questions || {};
  const readinessNumber = readinessQuestions.readiness_id
    || "";
  const swmsVersion = projectDetails.swms_version || context.swmsVersion;
  const shiftId = readinessQuestions.shift_id || context.shiftId || "";

  return (
    <div className={styles.PreviewDocBand} style={{ borderBottom: "4px solid #70ad5a" }}>
      <div className={styles.PreviewDocBandLetter}>
        <div className={styles.PreviewDocBandMark}>{orgLetter}</div>
        <div>
          <div className={styles.PreviewDocBandName}>{orgName}</div>
          <div className={styles.PreviewDocBandSub} style={{ color: "#bfddb4", fontWeight: 800 }}>RESCUE READINESS CHECKLIST</div>
        </div>
      </div>
      <div className={styles.PreviewDocBandRight} style={{ textAlign: "right" }}>
        <div className={styles.PreviewDocBandNo}>
          <span
            style={{
              display: "inline-block",
              verticalAlign: "2px",
              background: "#70ad5a",
              color: "#fff",
              fontSize: "10px",
              fontWeight: 800,
              letterSpacing: "0.8px",
              padding: "3px 9px",
              borderRadius: "999px",
              marginRight: "9px",
              lineHeight: 1
            }}
          >
            RDY
          </span>
          {readinessNumber}
        </div>
        <div style={{ fontWeight: 600, color: "#b8a8ef" }}>Rev {getRevisionNumber(swmsVersion)} &middot; Shift {shiftId} &middot; {swmsNumber}</div>
        <div style={{ fontWeight: 600, color: "#b8a8ef" }}>Controlled — Uncontrolled if Printed</div>
      </div>
    </div>
  );
}
